import { ChangeDetectorRef, Component, ContentChild, Input, inject } from '@angular/core';
import { Logger } from '@df/core/service/logger';
import { InputWrapBodyForceDirective } from './input-wrap-body-force.directive';
import { InputWrapBodyDirective } from './input-wrap-body.directive';
import { ValidationComponent } from './validation.component';

@Component({
    selector: 'input-wrap',
    templateUrl: './input-wrap.html',
    host: {
        class: 'input-wrap'
    },
    standalone: true,
    imports: [ValidationComponent]
})
export class InputWrapComponent {
    @Input()
    set disabled(value: boolean) {
        this._disabled = value;
    }

    get disabled() {
        if (this._disabled !== undefined) {
            return this._disabled;
        }

        if (this.body) {
            return this.body.nativeElement.disabled;
        }

        return false;
    }

    protected _disabled?: boolean;

    @Input()
    set required(value: boolean) {
        this._required = value;
    }
    /**
     * Required flag getter
     * Manual flag has priority, but normally we follow wrapped element
     */
    get required(): boolean {
        if (this._required !== undefined) {
            return this._required;
        }

        if (this.body) {
            return this.body.nativeElement.required;
        }

        return false;
    }

    protected _required?: boolean;

    /**
     * Field label
     */
    @Input()
    label?: string;

    @Input()
    helperMessages?: string[];

    /**
     * Custom error messages passed via attr
     */
    @Input()
    messages?: { [error: string]: string };

    @Input()
    canShowValidate?: boolean;

    /**
     * Wrapped element
     */
    @ContentChild(InputWrapBodyDirective, { static: false })
    defaultBody!: InputWrapBodyDirective;

    bodyForce?: InputWrapBodyForceDirective;

    protected changeDetectionRef = inject(ChangeDetectorRef);
    protected logger = inject(Logger);

    get body() {
        return this.bodyForce || this.defaultBody;
    }

    get inputId(): string | undefined {
        return this.body?.nativeElement?.id;
    }

    ngAfterViewInit() {
        if (!this.defaultBody) {
            this.logger.info('InputWrapComponent: no directive `InputWrapBodyDirective` provided');
        }
    }

    detectChanges(): void {
        this.changeDetectionRef.detectChanges();
    }
}
